import { useApplicationContext } from 'shared/utils/applicationContext';
import { ERuntimeSettings } from 'shared/types/runtimeSettings';

export const useIsMortgageRedirectEnabled = (): boolean =>
  useApplicationContext().config.get<boolean>(ERuntimeSettings.isMortgageRedirectEnabled) ?? false;
